import React, { useId } from 'react';
import { Card, CardContent, CardHeader } from '@mui/material';
import { StaffSuccessUpdates } from '../types';
import { clientUpdatesSummary } from '../utils/successUpdates';
import { ClientUpdatesList } from './ClientUpdatesList';

export interface ClientUpdatesCardProps {
  updates: StaffSuccessUpdates;
}

/** A coach's own overdue clients and those awaiting a first update, with the counts as a summary line. */
export const ClientUpdatesCard: React.FC<ClientUpdatesCardProps> = ({ updates }) => {
  const titleId = useId();

  return (
    <Card component="section" aria-labelledby={titleId}>
      <CardHeader
        title="Client success updates"
        titleTypographyProps={{ id: titleId, component: 'h2', variant: 'h6' }}
        subheader={clientUpdatesSummary(updates.counts)}
        sx={{ pb: 1 }}
      />
      <CardContent sx={{ pt: 0 }}>
        <ClientUpdatesList updates={updates} />
      </CardContent>
    </Card>
  );
};
